import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a49cc26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "validate" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 col-12 mx-auto" }
const _hoisted_5 = { class: "card card-body shadow-sm p-4" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "token" }, "Validating Token", -1))
const _hoisted_8 = {
  key: 0,
  class: "overlay"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item" }, "Validating Token", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", {
              onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.activate && _ctx.activate(...args)))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control mb-3",
                  name: "token",
                  id: "token",
                  placeholder: "Enter token",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.token) = $event)),
                  disabled: "",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.token]
                ])
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_ProgressSpinner),
          _hoisted_9
        ]))
      : _createCommentVNode("", true)
  ]))
}